export default __webpack_public_path__ + "static/media/b&a-woman-desk-last-below.cf6ea6bb.png";